import { useCallback } from 'react';
import { api } from '../utils/apiHandler';
import type { AxiosResponse } from 'axios';
import type { RadarChartResponse } from './types/radarTypes';

const USERS_PATH = '/users';

const useRadarResource = () => {
  // Fetch user radar chart
  const getRadar = useCallback(async (user_handle: string): Promise<RadarChartResponse> => {
    const response: AxiosResponse<RadarChartResponse> = await api.request<undefined, AxiosResponse<RadarChartResponse>>({
      method: 'GET',
      url: `${USERS_PATH}/${user_handle}/radar`
    });
    return response.data;
  }, []);

  return { getRadar };
};

export default useRadarResource;
